import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Share from '../../../../component/share';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../../../common/seoUpdateTime';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            title,
            dateTime,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            subscribe,
            updateTime,
            publishTime,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const props =
            !fhhAccountDetail.forbidJump && fhhAccountDetail.authorUrl
                ? {
                      href: fhhAccountDetail.authorUrl,
                      target: '_blank',
                  }
                : {};

        return (
            <div>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <p className={styles.time}>
                        <VisibleSeoTime publishTime={publishTime} className={styles.date}>
                            {dateTime}
                        </VisibleSeoTime>
                        <HiddenSeoTime publishTime={publishTime} updateTime={updateTime} />
                        <br />
                        <span style={{ verticalAlign: 'bottom' }}>{fhhAccountDetail.catename ? '来源：' : ''}</span>
                        <span className={styles.publisher}>
                            {!fhhAccountDetail.catename ? (
                                <span className={styles.source}>
                                    {fhhAccountDetail.authorUrl ? (
                                        <a href={fhhAccountDetail.authorUrl} target="_blank">
                                            {fhhAccountDetail.catename}
                                        </a>
                                    ) : (
                                        <span>{fhhAccountDetail.catename}</span>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.source}>
                                    <a {...props}>{fhhAccountDetail.catename}</a>
                                </span>
                            )}
                            <span>&nbsp;&nbsp;{subscribe?.lastArticleAddress || ''}</span>
                        </span>
                    </p>
                    <div className={styles.share_box}>
                        <Share shareInfo={shareInfo} />
                    </div>
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
